import { KdsTextArea } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useFormContext } from "react-hook-form";

import { type PreMediaClientRequestDetailsFormSchema } from "@/modals/ModalPreMediaClientRequestDetailsForm";

interface PreMediaBriefSectionProps {
  isPreMediaBriefMissing: boolean;
}

export const PreMediaBriefSection = ({
  isPreMediaBriefMissing,
}: PreMediaBriefSectionProps) => {
  const { t } = useTranslate();
  const methods = useFormContext<PreMediaClientRequestDetailsFormSchema>();

  return (
    <KdsTextArea
      label={t(
        "order.catalogMediumConfiguration.stepVersions.preMedia.description"
      )}
      hasError={isPreMediaBriefMissing}
      errorMessage={t("inputs.requiredField")}
      placeholder={t(
        "order.catalogMediumConfiguration.stepVersions.preMedia.descriptionPlaceholder"
      )}
      {...methods.register("preMediaBrief")}
    />
  );
};
